import { app } from 'config/ApiService';
import { getFunctions, httpsCallable, HttpsCallableResult } from 'firebase/functions';

/**
 * CaseHandler class to manage patient cases
 */
class CaseHandler {
    private callable;
    private regionOrDomainConfig: { [key: string]: string } = {
        us: 'us-central1',
        gb: 'europe-west2',
        aus: 'australia-southeast1',
        au: 'australia-southeast1'
    };
    /**
     * Constructor for CaseHandler
     * @param {string} region - The region
     */
    constructor(region: string) {
        const regionOrDomain = this.regionOrDomainConfig[region] || 'us-central1';
        this.callable = getFunctions(app, regionOrDomain);
    }

    /**
     * Discharge a patient case
     * @param {object} dischargeConfig - Discharge configuration
     */
    async dischargePatient(dischargeConfig: {
        userId: string;
        region: string;
        dischargeReason: string;
        treatmentNote: string;
        emailSubject: string;
        emailBody: string;
        patientMessage: string;
        customerNote: string;
        appOverlayHeader: string;
        appOverlayMessage: string;
    }): Promise<void> {
        const endpoint = httpsCallable(this.callable, 'phioengage-casework-casedischarge');
        await endpoint({
            user_id: dischargeConfig.userId,
            region: dischargeConfig.region,
            discharge_reason: dischargeConfig.dischargeReason,
            treatment_note: dischargeConfig.treatmentNote,
            email_content: dischargeConfig.emailBody,
            patient_message: dischargeConfig.patientMessage,
            customer_note: dischargeConfig.customerNote,
            app_overlay_header: dischargeConfig.appOverlayHeader,
            app_overlay_message: dischargeConfig.appOverlayMessage,
            email_subject: dischargeConfig.emailSubject
        });
    }

    /**
     * Reinstate a discharged patient case
     * @param {string} userId - The patient ID
     */
    async reinstateCase(userId: string): Promise<void> {
        const endpoint = httpsCallable(this.callable, 'phioengage-casework-reinstate');
        await endpoint({
            user_id: userId
        });
    }

    /**
     * get discharge report as base64 string
     * @param userId
     * @param episodeId
     * @returns {Promise<string>} - base64 string of the discharge report PDF
     */
    async getdischargeReport(
        userId: string,
        episodeId?: string
    ): Promise<HttpsCallableResult<unknown>> {
        return httpsCallable(
            this.callable,
            'phioengage-pdf-getdischargereport'
        )({
            user_id: userId,
            episode_id: episodeId
        });
    }

    /**
     *
     * @param userId
     * @param param
     * @returns
     */
    async reviewDischarge(
        userId: string,
        param: { [key: string]: any }
    ): Promise<HttpsCallableResult<unknown>> {
        return httpsCallable(
            this.callable,
            'phioengage-casework-reviewdischarge'
        )({
            id: userId,
            ...param
        });
    }
}

export default CaseHandler;
